import React, { useState, useEffect } from "react";
import {
  FaUser, FaPhone, FaEnvelope, FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { MdAccountBalance } from "react-icons/md";
import { MdOutlineAccountCircle } from "react-icons/md";
import { BsBank } from "react-icons/bs";
import { CgDanger } from "react-icons/cg";
import axios from 'axios'
import toast from "react-hot-toast";
import socket from "../socket";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function CustomerEnquiry({ token }) {
    const navigate = useNavigate();
  const [fetchWeb, setFetchWeb] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [getDealer, setGetDealer] = useState([]);

  const [showDealerModal, setShowDealerModal] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [showDealerViewModal, setShowDealerViewModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [rejectRemark, setRejectRemark] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [showSaleModal, setShowSaleModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showCancelRefund, setShowCancelRefund] = useState(false);
  const [remark, setRemark] = useState("");
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const [selectedCity, setSelectedCity] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [selectedDelete, setSelectedDelete] = useState(null);
 const [statusFilter, setStatusFilter] = useState("All");

  
useEffect(() => {
  const handleNewEnquiry = (data) => {
    fetchCutEnquiry();
    toast.success(data.title);
  };


  socket.on("new-enquiry", handleNewEnquiry);

  return () => {
    socket.off("new-enquiry", handleNewEnquiry);
    socket.off("connect");
  };
}, []);


useEffect(() => {
  const handleRefundRequest = (data) => {
    fetchCutEnquiry();
    toast.success(data.title);
  };

  // socket.on("connect", () => {
  //   console.log("Socket connected:", socket.id);
  // });

  socket.on("refund-request", handleRefundRequest);

  return () => {
    socket.off("refund-request", handleRefundRequest);
    socket.off("connect");
  };
}, []);



  const fetchCutEnquiry = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-custumer-enquiry",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;
      const uniqueStates = [
        ...new Set(result.map(item => item.cust_state).filter(Boolean))
      ];

      setStates(uniqueStates);
      setFetchWeb(result);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDealerByState = async (state) => {
    try {

      const res = await axios.get(
        `https://api.krimotion.in/fetch-dealer-state-list/${encodeURIComponent(state)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      const dealers = res.data;

      setDealerList(dealers);


      // create unique city list
      const uniqueCities = [
        ...new Set(
          dealers
            .map((dealer) => dealer.city)
            .filter(Boolean)
        )
      ];

      setCityList(uniqueCities);


    } catch (error) {
      console.log("Dealer fetch error:", error);
    }
  };

  const fetchDealer = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-dealers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = res.data;

      const filteredSorted = result
        .filter((item) => item.id !== 1)
        .sort((a, b) => b.id - a.id);

      setGetDealer(filteredSorted);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchCutEnquiry();

  }, []);




  const handleAllotDealer = async () => {
    if (!selectedDealer) {
      toast.warning("Please select a dealer.");
      return;
    }

    try {
      await axios.put(
        `https://api.krimotion.in/allot-dealer/${selectedCustomer.id}`,
        {
          cust_id:selectedCustomer.cust_id,
          dealer_id: selectedDealer,
          alloted_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          enquire_status: "Alloted"
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Dealer allotted successfully.");

      setShowDealerModal(false);
      setSelectedDealer("");
      fetchCutEnquiry();
    } catch (error) {
      console.log(error);
      toast.error("Fail to alloted dealer.");
    }
  };

  const handleRejectEnquiry = async () => {
    try {
      await axios.put(
        `https://api.krimotion.in/reject-enquiry/${selectedEnquiry.id}`,
        {
          status: "Rejected",
          rej_remark: rejectRemark,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowRejectModal(false);
      setRejectRemark(""); // reset field

      fetchCutEnquiry();

      toast.success("Enquiry rejected successfully.");
    } catch (error) {
      console.log(error);
      toast.error("Failed to reject enquiry.");
    }
  };


 

//not in used 
  const handleMarkSale = async () => {
    try {
      await axios.put(
        `https://api.krimotion.in/mark-sale/${selectedDealer.id}`,
        {
          enquire_status: "Closed",
          mark_sale: 'Yes'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Enquiry marked as sale successfully.");

      setShowSaleModal(false);

      // Refresh list
      fetchCutEnquiry();
    } catch (error) {
      console.error(error);
      toast.error("Failed to mark enquiry as sale.");
    }
  };


  const handleRefund = async () => {
    try {
      const res = await axios.put(
        `https://api.krimotion.in/update-machine-enq-refund/${selectedDriver.id}`,
        {
             cust_id:selectedDriver.cust_id,
          enquire_status: "Refund Completed",
          refund_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund completed successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };


  const handleCancelRefund = async () => {
    if (!remark.trim()) {
      toast.warning("Please enter remark.");
      return;
    }

    try {
      const res = await axios.put(
        `https://api.krimotion.in/cancel-machine-enq-refund/${selectedDriver.id}`,
        {
          cust_id:selectedDriver.cust_id,
          enquire_status: "Refund Cancelled",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          rej_remark: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund cancelled successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };


  const handleCloseEnquiry = async () => {

    try {
      const res = await axios.put(
        `https://api.krimotion.in/close-machine-enquiry/${selectedData.id}`,
        {
          enquire_status: "Closed",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          otp: otp,

        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Enquiry closed successfully.");

      setShowCloseModal(false);
      setSelectedData(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);

      if (err.response?.status === 400) {
        setOtpError(err.response.data.message);
        // setShowCloseModal(false);
      } else {
        toast.error("Failed to close enquiry.");
        setShowCloseModal(false);
      }
    }
  }


   const handleDeleteEnquiry = async () => {
  try {
    const res = await axios.delete(
      `https://api.krimotion.in/delete-machine-enquiry/${selectedDelete.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success(res.data.message);

    setShowDeleteModal(false);
    setSelectedDelete(null);

    fetchCutEnquiry(); 
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };


  const filteredDealers = dealerList.filter(
    dealer => dealer.city === selectedCity
  );

//  const filteredData = Array.isArray(fetchWeb)
//     ? fetchWeb.filter(itm =>
//       Object.values(itm).some(val =>
//         String(val).toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     )
//     : [];

const filteredData = Array.isArray(fetchWeb)
  ? fetchWeb.filter((itm) => {
      const matchesSearch = Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      );

      // Status filter
      const matchesStatus =
        statusFilter === "All"
          ? true
          : itm.enquire_status === statusFilter;

      return matchesSearch && matchesStatus;
    })
  : [];


  const statusOptions = [
  "All",
  ...new Set(
    Array.isArray(fetchWeb)
      ? fetchWeb.map((item) => item.enquire_status)
      : []
  ),
];


  return (
    <div className="container py-4">


      <div className="border-0  mb-3 px-2 py-2  ">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Machine Enquiry
            </h4>
          </div>

          {/* CENTER SEARCH */}
          <div style={{ flex: 1, maxWidth: "250px" }}>
            <div
              className="d-flex align-items-center rounded-pill overflow-hidden"
              style={{
                border: "1px solid var(--green)",
                height: "34px",
                paddingLeft: "8px",
                paddingRight: "8px",
                backgroundColor: 'white'
              }}
            >
              {/* ICON */}
              <FaSearch
                style={{
                  color: "var(--green)",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center"
                }}
              />

              {/* INPUT */}
              <input
                type="text"
                className="form-control border-0 shadow-none"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  fontSize: "14px",
                  height: "32px",
                  marginLeft: "6px",
                  lineHeight: "32px"
                }}
              />
            </div>
          </div>



        </div>
      </div>

 

{!showForm && (

<>

  <>
    <div className="d-flex justify-content-end align-items-center mb-3">
      <div style={{ width: "200px" }}>
        <select
          className="form-select shadow-sm"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          {statusOptions.map((status, index) => (
            <option key={index} value={status}>
              {status}
            </option>
          ))}
        </select>
      </div>
    </div>

  
  </>

<div className="container-fluid mt-4">

    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (

          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

         
              <div className="d-flex justify-content-between align-items-start">

                <div>
                  <h5 className="inventory-title mb-1">
                    {dealer.cust_name}
                  </h5>

                  <small className="text-muted">
                    {dealer.cust_mobile}
                  </small>
                </div>

                <span className="badge bg-primary">
                  ₹ {dealer.sell_price}
                </span>

              </div>

              <hr />

   

              <div className="inventory-row">
                <span className="inventory-label">
                  Machine
                </span>
                <span>{dealer.machine_name}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Status
                </span>
                <span>{dealer.enquire_status}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Added On
                </span>
                <span>{formatDate(dealer.enquire_on)}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Dealer
                </span>
                <span>{dealer.dealer_name || "Not Alloted"}</span>
              </div>

     

              <div className="mt-auto pt-3">

                <div className="d-flex flex-wrap gap-2">

                  {dealer.enquire_status !== "Refund Completed" &&
                    dealer.enquire_status !== "Refund Request" &&
                    dealer.enquire_status !== "Refund Cancelled" &&
                    dealer.enquire_status !== "Closed" &&
                    dealer.enquire_status !== "Cancelled" &&
                    dealer.enquire_status !== "Alloted" &&
                    dealer.enquire_status !== "Accepted" &&
                    dealer.rejected_by !== "customer" && (

                      <button
                        className={`btn-action ${
                          dealer.rejected_by === "dealer"
                            ? "btn-warning-custom"
                            : "btn-primary-custom"
                        }`}
                        onClick={() => {
                          setSelectedCustomer(dealer);
                          setShowDealerModal(true);
                          fetchDealer();
                        }}
                      >
                        {dealer.rejected_by === "dealer"
                          ? "Allotted Again"
                          : "Allotted Dealer"}
                      </button>
                  )}

                  {dealer.enquire_status !== "Refund Request" &&
                    dealer.enquire_status !== "Refund Completed" &&
                    dealer.enquire_status !== "Refund Cancelled" &&
                    dealer.enquire_status !== "Closed" &&
                    dealer.enquire_status !== "Cancelled" &&
                    dealer.dealer_id && (

                      <button
                        className="btn-action btn-success-custom"
                        onClick={() => {
                          setSelectedDealer(dealer);
                          setShowDealerViewModal(true);
                        }}
                      >
                        View Dealer
                      </button>
                  )}

                  {dealer.enquire_status === "Closed" && (
                    <span className="status-badge status-success">
                      Closed
                    </span>
                  )}

                  {(dealer.enquire_status === "Refund Request" ||
                    dealer.enquire_status === "Refund Completed" ||
                    dealer.enquire_status === "Refund Cancelled") && (

                    <button
                      className={`btn-action ${
                        dealer.enquire_status === "Refund Completed"
                          ? "btn-success-custom"
                          : dealer.enquire_status === "Refund Cancelled"
                          ? "btn-danger-custom"
                          : "btn-warning-custom"
                      }`}
                      onClick={() => {
                        setSelectedDriver(dealer);
                        setShowRefundModal(true);
                      }}
                      disabled={
                        dealer.enquire_status === "Refund Completed" ||
                        dealer.enquire_status === "Refund Cancelled"
                      }
                    >
                      {dealer.enquire_status === "Refund Completed"
                        ? "Refunded"
                        : dealer.enquire_status === "Refund Cancelled"
                        ? "Refund Rejected"
                        : "Refund"}
                    </button>
                  )}

                  {(dealer.enquire_status === "Converted" ||
                    dealer.enquire_status === "Refund Cancelled") && (

                    <button
                      className="btn-action btn-danger-custom"
                      onClick={() => {
                        setSelectedData(dealer);
                        setShowCloseModal(true);
                      }}
                    >
                      Closed
                    </button>
                  )}

                  {dealer.enquire_status === "Cancelled" && (
                    <span className="status-badge status-danger">
                      Cancelled
                    </span>
                  )}

                  <button
                    className="btn-action btn-secondary-custom"
                    onClick={() => {
                      setSelectedDelete(dealer);
                      setShowDeleteModal(true);
                    }}
                  >
                    <MdDeleteForever className="me-1" />
                    Delete
                  </button>


                        <button
  className="btn-action btn-success-custom"
  onClick={() =>
    navigate("/admin/chat-history", {
      state: {
        dealer: dealer,
        enq_type:"Machine", 
      },
    })
  }
>
  View Chat
</button>

                </div>

              </div>

            </div>

          </div>

        ))
      ) : (
        <div className="col-12 text-center py-5">
          <h5>No Data Found</h5>
        </div>
      )}

    </div>
  </div>
</>

)}

      {showDealerModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDealerModal(false)}
          ></div>

          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "18px" }}
              >
                {/* Header */}
                <div
                  className="modal-header text-white"
                  style={{
                    background: "linear-gradient(135deg, #0d6efd, #0a58ca)",
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: "18px",
                  }}
                >
                  <div>
                    <h5 className="mb-1 fw-bold">
                      {selectedCustomer.rejected_by == 'dealer' ? " 🚜Alloted Again " : "🚜 Allot Dealer"}
                      {/* 🚜 Allot Dealer */}
                    </h5>
                    <small className="text-light">
                      Assign this enquiry to a dealer
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowDealerModal(false)}
                  ></button>
                </div>

                <div className="card border-0 bg-light mb-3">
                  <div className="card-body py-3">
                    <h6 className="fw-bold mb-3">Customer Details</h6>

                    <div className="row">
                      <div className="col-6">
                        <small className="text-muted d-block">State</small>
                        <span>{selectedCustomer.cust_state || "-"}</span>
                      </div>

                      <div className="col-6">
                        <small className="text-muted d-block">City</small>
                        <span>{selectedCustomer.cust_city || "-"}</span>
                      </div>
                    </div>
                  </div>
                </div>



                {/* Body */}
                <div className="modal-body p-4">

                  <div className="text-center mb-4">
                    <div
                      className="mx-auto d-flex align-items-center justify-content-center"
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        background: "#e7f1ff",
                        fontSize: "30px",
                      }}
                    >
                      👨‍💼
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Select State
                    </label>

                    <select
                      className="form-select form-select-lg"
                      value={selectedState}
                      onChange={(e) => {

                        const state = e.target.value;

                        setSelectedState(state);

                        if (state) {
                          fetchDealerByState(state);
                        }

                      }}
                    >

                      <option value="">
                        Choose State
                      </option>

                      {
                        states.map((state, index) => (
                          <option key={index} value={state}>
                            {state}
                          </option>
                        ))
                      }

                    </select>
                  </div>

                  <div className="mb-3">

                    <label className="form-label fw-semibold">
                      Select City
                    </label>


                    <select
                      className="form-select form-select-lg"
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                    >

                      <option value="">
                        Choose City
                      </option>


                      {
                        cityList.map((city, index) => (
                          <option key={index} value={city}>
                            {city}
                          </option>
                        ))
                      }


                    </select>

                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Select Dealer
                    </label>

                  
                    <select
                      className="form-select form-select-lg"
                      value={selectedDealer}
                      onChange={(e) => setSelectedDealer(e.target.value)}
                    >

                      <option value="">
                        Choose Dealer
                      </option>


                      {
                        filteredDealers.map((dealer, index) => (

                          <option
                            key={index}
                            value={dealer.id}
                          >
                            {dealer.name}
                          </option>

                        ))
                      }


                    </select>

                    <small className="text-muted">
                      Select the dealer who will handle this enquiry.
                    </small>
                  </div>
                  {selectedCustomer.rejected_by === "dealer" && (
                    <div className="alert alert-warning">
                      <strong>Notice:</strong> This enquiry was rejected by{" "}
                      <strong>{selectedCustomer.dealer_name}</strong> on{" "}
                      <strong>{formatDate(selectedCustomer.rejected_on)}</strong>.
                    </div>
                  )}

                </div>

                {/* Footer */}
                <div className="modal-footer border-0 px-4 pb-4">

                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => setShowDealerModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary px-4"
                    onClick={handleAllotDealer}
                  >
                    💾 Save Allotment
                  </button>

                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {showDealerViewModal && selectedDealer && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDealerViewModal(false)}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg rounded-4">

                <div className="modal-header bg-success text-white">
                  <h5 className="fw-bold mb-0">
                    👨‍💼 Dealer Details
                  </h5>

                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowDealerViewModal(false)}
                  ></button>
                </div>

                <div className="modal-body">

                  {/* Dealer Information */}
                  <div className="card border-0 shadow-sm mb-4">
                    <div className="card-header bg-light">
                      <strong>Dealer Information</strong>
                    </div>

                    <div className="card-body">
                      <div className="row">

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Dealer Name</label>
                          <h6>{selectedDealer.dealer_name}</h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Mobile</label>
                          <h6>{selectedDealer.dealer_mobile}</h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Bussiness Name</label>
                          <h6>{selectedDealer.buss_name}</h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Address</label>
                          <h6
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >{selectedDealer.dealer_add}</h6>
                        </div>

                      </div>
                    </div>
                  </div>

                  {/* Payment Details */}
                  <div className="card border-0 shadow-sm">

                    <div className="card-header bg-light">
                      <strong> Dealer Enquiry Payment</strong>
                    </div>

                    <div className="card-body">

                      <div className="row">

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Advance Amount</label>
                          <h6 className="text-success">
                            ₹ {selectedDealer.amount}
                          </h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Payment ID</label>
                          <h6 className="text-dark">
                            {selectedDealer.pay_id}
                          </h6>
                        </div>

                            <div className="col-md-6 mb-3">
                          <label className="text-muted">Payment Mode</label>
                          <h6 className="text-dark">
                            {selectedDealer.pay_mode}
                          </h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Enquiry Purchase Date</label>
                          <h6>{formatDate(selectedDealer.enq_pur_date)}</h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Enquiry Purchase Status </label>

                          <div className="mt-1">
                            <span
                              className={`badge ${selectedDealer.enq_pay_status === "Success"
                                  ? "bg-success"
                                  : "bg-warning text-dark"
                                }`}
                            >
                              {selectedDealer.enq_pay_status} 
                            </span>
                            
                          </div>
                        </div>

                         <div className="col-md-6 mb-3">
                          <label className="text-muted">Enquiry Type</label>
                          <h6>{selectedDealer.enq_pay_type}</h6>
                        </div>

                      </div>

                    </div>

                  </div>

  
                    <div className="card border-0 shadow-sm">

                    <div className="card-header bg-light">
                      <strong>Customer Advance Payment Details </strong>
                    </div>

                    <div className="card-body">

                      <div className="row">

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Advance Amount</label>
                          <h6 className="text-success">
                            ₹ {selectedDealer.advance_amt}
                          </h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Payment ID</label>
                          <h6 className="text-dark">
                            {selectedDealer.advance_pay_id}
                          </h6>
                        </div>

                           <div className="col-md-6 mb-3">
                          <label className="text-muted">Payment Mode</label>
                          <h6 className="text-dark">
                            {selectedDealer.advance_mode}
                          </h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Pay Date</label>
                          <h6>{formatDate(selectedDealer.advance_date)}</h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-muted">Pay Status</label>

                          <div className="mt-1">
                            <span
                              className={`badge ${selectedDealer.advance_pay_status === "Success"
                                  ? "bg-success"
                                  : "bg-warning text-dark"
                                }`}
                            >
                              {selectedDealer.advance_pay_status}
                            </span>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDealerViewModal(false)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}

      {showDeleteModal && (
  <>
    <div
      className="modal-backdrop fade show"
      onClick={() => setShowDeleteModal(false)}
    ></div>

    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "16px" }}
        >
       
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title fw-bold">
              🗑 Delete Enquiry
            </h5>

            <button
              className="btn-close btn-close-white"
              onClick={() => setShowDeleteModal(false)}
            ></button>
          </div>

      
          <div className="modal-body text-center py-4">

            <div style={{ fontSize: "60px" }}>⚠️</div>

            <h5 className="mt-3 fw-bold">
              Are you sure?
            </h5>

            <p className="text-muted mb-0">
              You are about to permanently delete this enquiry.
            </p>

            <p className="text-danger fw-semibold mt-2">
              This action cannot be undone.
            </p>

          </div>

       
          <div className="modal-footer border-0 justify-content-center">

            <button
              className="btn btn-outline-secondary px-4"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDeleteEnquiry}
            >
              🗑 Delete
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)}

      {showRejectModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowRejectModal(false)}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "16px" }}
              >
                {/* Header */}
                <div className="modal-header bg-warning text-dark">
                  <h5 className="modal-title fw-bold">
                    ❌ Reject Enquiry
                  </h5>

                  <button
                    className="btn-close"
                    onClick={() => setShowRejectModal(false)}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body text-center py-3">

                  <div style={{ fontSize: "50px" }}>⚠️</div>

                  <h5 className="mt-3 fw-bold">
                    Are you sure you want to reject this enquiry?
                  </h5>

                  <p className="text-muted">
                    Please add a reason for rejection (optional but recommended).
                  </p>

                  {/* Remarks Input */}
                  <textarea
                    className="form-control mt-3"
                    rows="3"
                    placeholder="Enter rejection remark..."
                    value={rejectRemark}
                    onChange={(e) => setRejectRemark(e.target.value)}
                  />
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 justify-content-center">

                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-warning px-4"
                    onClick={handleRejectEnquiry}
                  >
                    ❌ Reject
                  </button>

                </div>

              </div>
            </div>
          </div>
        </>
      )}


      {showSaleModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowSaleModal(false)}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "16px" }}
              >
                {/* Header */}
                <div className="modal-header bg-success text-white">
                  <h5 className="modal-title fw-bold">
                    ✅ Mark as Sale
                  </h5>

                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowSaleModal(false)}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body text-center py-4">
                  <div style={{ fontSize: "55px" }}>💰</div>

                  <h5 className="mt-3 fw-bold">
                    Are you sure?
                  </h5>

                  <p className="text-muted mb-0">
                    You are about to mark this enquiry as <strong>Sale</strong>.
                  </p>

                  <p className="text-success fw-semibold mt-2">
                    This action will update the enquiry status.
                  </p>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 justify-content-center">
                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => setShowSaleModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-success px-4"
                    onClick={handleMarkSale}
                  >
                    ✅ Confirm Sale
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showRefundModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                className="position-relative text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#dc3545,#ef4444)",
                }}
              >

                <button
                  className="btn btn-sm btn-light position-absolute"
                  style={{
                    top: 15,
                    right: 15,
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                  }}
                  onClick={() => {
                    setShowRefundModal(false);
                    setShowCancelRefund(false);
                    setRemark("");
                  }}
                >
                  ✕
                </button>

                <div
                  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }}
                >
                  <FaUserCheck size={34} color="#fff" />
                </div>

                <h4 className="text-white fw-bold mt-3">
                  Confirm Refund
                </h4>
              </div>

              {/* Body */}
             <div className="p-4">
  <div className="text-center mb-4">
    <h4 className="fw-bold mb-1">{selectedDriver?.cust_name}</h4>
   
  </div>

  <div className="card border-0 shadow-sm">
    <div className="card-body">

      <div className="row mb-3">
        <div className="col-5 fw-semibold text-muted">
          Account No
        </div>
        <div className="col-7">
          {selectedDriver?.cust_acc}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-5 fw-semibold text-muted">
          Verification
        </div>
        <div className="col-7">
          <span
            className={`badge ${
              selectedDriver?.cust_verify == 1
                ? "bg-success"
                : "bg-danger"
            }`}
          >
            {selectedDriver?.cust_verify == 1
              ? "Verified"
              : "Not Verified"}
          </span>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-5 fw-semibold text-muted">
          Refund Amount
        </div>
        <div className="col-7 fw-bold text-success">
          ₹
          {(
            Number(selectedDriver?.sell_price || 0) -
            Number(selectedDriver?.platform_fee || 0)
          ).toFixed(2)}
        </div>
      </div>

      <div className="row">
        <div className="col-5 fw-semibold text-muted">
          Current Status
        </div>
        <div className="col-7">
          <span className="badge bg-warning text-dark">
            {selectedDriver?.enquire_status}
          </span>
        </div>
      </div>

    </div>
  </div>

  <p className="text-center text-muted mt-4 mb-0">
    Are you sure you want to refund this booking?
  </p>

  {showCancelRefund && (
    <div className="mt-4">
      <label className="form-label fw-semibold">
        Cancellation Remark
      </label>

      <textarea
        className="form-control"
        rows={4}
        placeholder="Enter cancellation remark..."
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </div>
  )}
</div>

              {/* Footer */}
              <div className="px-4 pb-4">
                {!showCancelRefund ? (
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-danger w-50"
                      onClick={handleRefund}
                    >
                      Confirm Refund
                    </button>

                    <button
                      className="btn btn-outline-secondary w-50"
                      onClick={() => setShowCancelRefund(true)}
                    >
                      Cancel Refund
                    </button>
                  </div>
                ) : (
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-secondary w-50"
                      onClick={() => {
                        setShowCancelRefund(false);
                        setRemark("");
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="btn btn-danger w-50"
                      onClick={handleCancelRefund}
                    >
                      Cancel This Refund
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showCloseModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                className="text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#dc3545,#b91c1c)",
                }}
              >
                <div
                  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.2)",
                  }}
                >

                  <CgDanger style={{ fontSize: "34px", color: 'white' }} />
                </div>

                <h4 className="text-white fw-bold mt-3 mb-0">
                  Close Enquiry
                </h4>
              </div>

              {/* Body */}
              <div className="p-4 text-center">
                <h5 className="fw-bold mb-2">
                  {selectedData?.name}
                </h5>

                <p className="text-muted mb-4">
                  Are you sure you want to <strong>close this enquiry</strong>?
                  <br />
                  This action will mark the enquiry as closed and it will no longer
                  be available for assignment.
                </p>

                <div
                  className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                  style={{
                    background: "#fde8e8",
                  }}
                >
                  <span className="me-2 fw-semibold text-dark">
                    Current Status
                  </span>

                  <span className="badge bg-success">
                    {selectedData?.enquire_status}
                  </span>
                </div>
              </div>

              <div className="mb-3 px-4">
                <label className="form-label fw-semibold">Enter OTP</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value);
                    setOtpError("");
                  }}
                />

                {otpError && (
                  <small className="text-danger">{otpError}</small>
                )}
              </div>

              {/* Footer */}
              <div className="px-4 pb-4 d-flex gap-3">
                <button
                  className="btn btn-light border w-50"
                  style={{ borderRadius: "10px" }}
                  onClick={() => setShowCloseModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger w-50"
                  style={{
                    borderRadius: "10px",
                    fontWeight: 600,
                  }}
                  onClick={handleCloseEnquiry}
                >
                  <i className="bi bi-lock-fill me-2"></i>
                  Yes, Close Enquiry
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default CustomerEnquiry
